module.exports = __webpack_public_path__ + "static/favicon-8f7ceb7dda044bd1fda764a90cfd8e2c.ico";